export default "__VITE_ASSET__HkBtZLB5__"